import { useEffect, useState } from "react";
import { billingApi } from "../api/businessData.js";

// Landing page for Paysera's accepturl/cancelurl redirects. These are UX-only —
// the query params on this URL are never treated as proof of payment (a user's
// browser controls that navigation and it can be spoofed). We poll the real
// server-side status, which only reflects webhook-confirmed payments.
export function BillingCallbackPage({ outcome }) {
  const [status, setStatus] = useState(null);
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (status?.subscription?.status === "active") return;
    if (attempts >= 15) return; // ~30s of polling, then give up waiting

    const timer = setTimeout(async () => {
      try {
        const s = await billingApi.getStatus();
        setStatus(s);
      } catch {
        // ignore, will retry
      } finally {
        setAttempts((a) => a + 1);
      }
    }, 2000);
    return () => clearTimeout(timer);
  }, [attempts, status]);

  const confirmed = status?.subscription?.status === "active";

  return (
    <div style={{ minHeight: "100vh", background: "#F5F6FA", display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
      <div style={{ background: "#fff", borderRadius: 14, padding: 32, maxWidth: 420, textAlign: "center", boxShadow: "0 8px 32px rgba(0,0,0,0.12)" }}>
        <div style={{ fontWeight: 900, fontSize: 20, color: "#735DFF", letterSpacing: 1, marginBottom: 16 }}>SANNAMAI</div>
        {confirmed ? (
          <>
            <h2 style={{ fontSize: 16, fontWeight: 700, color: "#2f6f4f", marginBottom: 8 }}>Mokėjimas patvirtintas</h2>
            <p style={{ fontSize: 14, color: "#383853", marginBottom: 16 }}>Jūsų planas aktyvuotas.</p>
          </>
        ) : outcome === "cancel" ? (
          <>
            <h2 style={{ fontSize: 16, fontWeight: 700, color: "#1C1C1C", marginBottom: 8 }}>Mokėjimas atšauktas</h2>
            <p style={{ fontSize: 14, color: "#383853", marginBottom: 16 }}>Galite bandyti dar kartą bet kada.</p>
          </>
        ) : (
          <>
            <h2 style={{ fontSize: 16, fontWeight: 700, color: "#1C1C1C", marginBottom: 8 }}>
              {attempts < 15 ? "Tikriname mokėjimą..." : "Mokėjimas dar apdorojamas"}
            </h2>
            <p style={{ fontSize: 14, color: "#383853", marginBottom: 16 }}>
              {attempts < 15
                ? "Tai gali užtrukti kelias sekundes."
                : "Jei mokėjimas buvo sėkmingas, planas bus aktyvuotas netrukus. Galite grįžti į programą."}
            </p>
          </>
        )}
        <a
          href="/"
          style={{ display: "inline-block", padding: "8px 20px", background: "#735DFF", color: "#fff", borderRadius: 8, fontSize: 13, fontWeight: 600, textDecoration: "none" }}
        >
          Grįžti į programą
        </a>
      </div>
    </div>
  );
}
